<template>
    <div class="add-promo-shop t-shops-row" style="overflow: visible;">
        <div class="c-tr p-0 gap-1 w-100 flex-row flex-wrap">
            <div class="c-td is-1">
                <h6 class="mb-0" v-text="merchant.name" />

                {{ setShopAddress(merchant) }}
            </div>

            <div v-if="!product.ean_present" class="c-td is-2 form-group mb-0">
                <span class="typo-label" v-text="'Kod lokalny'" />

                <local-code
                    class="mb-0"
                    invalid-feedback="'Kod musi być unikalny'"
                    :text="localCode"
                    :invalid="localCodeInvalid"
                    :invalid-icon="false"
                    :product="product"
                    @input="onTempLocalCodeChange($event)"
                />
            </div>

            <div v-if="!isMix" class="c-td is-2">
                <span class="typo-label" v-text="'Cena w promocji'" />

                <money-input
                    class="mb-0"
                    style="width: 6rem"
                    :price="promoPrice"
                    @onChange="
                        onTempPromoPriceChange($event)
                    "
                ></money-input>
            </div>

            <div class="c-td is-3">
                <span class="typo-label" v-text="'Cena poza promocją'" />

                <money-input
                    class="mb-0"
                    style="width: 6rem"
                    :price="normalPrice"
                    @onChange="
                        onNormalPriceChange(merchant.id, $event, product.id)
                    "
                ></money-input>
            </div>
        </div>

        <alt-ean-warning
            v-if="shopEanError"
            :alt-ean-error="shopEanError"
            class="ml-auto mt-3"
        />
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
import AltEanWarning from '@/components/promotions/altEans/AltEanWarning.vue'

export default {
    mixins: [addNewPromo],

    components: {
        AltEanWarning
    },

    props: {
        merchant: {
            type: Object,
            required: true
        },

        product: {
            type: Object,
            required: true
        }
    },

    computed: {
        prices() {
            return this.product.merchant_prices.find(
                mPrices => mPrices.merchant_id === this.merchant.id
            )
        },

        selectedMerchantIds() {
            return this.selectedMerchants.map(el => el.id)
        },

        localCodeInvalid() {
            return this.$store.getters.isNewPromoLocalCodeInvalid(
                this.merchant.id,
                this.prices.alternative_ean
            )
        },

        normalPrice() {
            return this.prices.normal_price
        },

        promoPrice() {
            return this.prices.promo_price
        },

        localCode() {
            return this.prices.alternative_ean
        },

        shopEanError() {
            if (!this.product.eanErrors) return

            return this.product.eanErrors.find(el => {
                return (
                    el.merchant_id === this.merchant.id &&
                    el.alternative_ean === this.localCode
                )
            })
        }
    },

    methods: {
        setShopAddress(data) {
            return this.$store.getters.getShopAddress(data)
        },
        onTempLocalCodeChange(code) {
            this.$set(this.prices, 'alternative_ean', code)
        },
        onTempPromoPriceChange(price) {
            this.$set(this.prices, 'promo_price', price)
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.t-shops-row.add-promo-shop {
    padding: 1rem;
    .c-td {
        padding: 0;
    }

    @include media-breakpoint-down(sm) {
        .is-1 {
            min-width: 100%;
        }
    }
}
</style>
